import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export function useScrollToHash() {
  const { hash } = useLocation()

  useEffect(() => {
    if (!hash) return

    const id = hash.replace('#', '')

    const scroll = () => {
      const el = document.getElementById(id)
      if (el) {
        // Final safety delay before scrolling
        setTimeout(() => {
          el.scrollIntoView({ behavior: 'smooth' })
        }, 200)
      }
    }

    // Wait 2 frames for layout to stabilize
    requestAnimationFrame(() => {
      requestAnimationFrame(scroll)
    })
  }, [hash])
}
